import AudiotracksListAbstract from './audiotracks-list.abstract.js';

const DEFAULTS = {
	tracks: [],
	default: 'defs' // id
};

/**
 * The class for managing moment list
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends AudiotracksListAbstract
 */
class AudiotracksList extends AudiotracksListAbstract {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options);
		super(player, options_);
		this.items = options_.tracks.slice();
		this._player = player;
	}

	isSelected(id) {
		let currAudioTrackId = this._player.hls_.audioTrack;
		let currAudioTrack = this._player.hls_.audioTracks.find((track) => track.id === currAudioTrackId);
		return Boolean(currAudioTrack) && currAudioTrack.name === id;
	}

	play(id) {
		let hls = this._player.hls_;
		if (!hls) return;

		let audioTracks = hls.audioTracks;
		let selectedAudioTrack = audioTracks.find((track) => track.name === id);
		hls.audioTrack = selectedAudioTrack.id;

		this._player.trigger('Audiotracks/changing-track');
	}
}

export default AudiotracksList;
